<template>
  <div id="Pdf" class="print-pdf">
    <div class="pdf-top flex">
      <div class="logo-blue">
        <img width="110" src="/assets/img/svg/logo-blue.svg" alt="HMC" />
      </div>
    </div>
    <h2 v-if="isSurgery" class="title tx--blue title--55 center">
      {{ activeDoctor.name }} | רשימת ניתוחים, {{ date }}
    </h2>
    <h2 v-else class="title tx--blue title--55 center">
      מרפאת {{ activeDoctor.name }} | {{ date }}
    </h2>
    <!-- TABLE -->
    <div v-if="appointmentList && appointmentList.length" class="pdf-table">
      <div class="pdf-table-head">
        <div
          v-for="event in appointmentList"
          :key="event.id"
          class="pdf-table-body"
        >
          <div class="tr flex">
            <div class="td td-1">{{ showTimes(event) }}</div>
            <div class="td td-2">
              <div>
                <span>מטופל: </span>
                <span class="lighten"
                  >{{ showName(event) }} ({{ showPassport(event) }})</span
                >
              </div>
              <div>
                <span>טל׳: </span>
                <span class="lighten">{{ showPhone(event) }}</span>
              </div>
              <span style="margin-left: 20px;">
                <span>גיל מטופל: </span>
                <span class="lighten">{{ event.patient_age }}</span>
              </span>
              <span>
                <span>מגדר: </span>
                <span class="lighten">{{ event.gender }}</span>
              </span>
            </div>
            <div class="td td-3" :style="isSurgery ? '' : 'width:21%;'">
              <template v-if="isSurgery && event.orders.length">
                <div v-for="(order, i) in event.orders" :key="i">
                  <span>ניתוח: </span>
                  <span class="lighten" style="margin-bottom:3px">
                    {{ order.tafnit_code + " > " }}
                    <span class="small-text">{{ order.tafnit_name }}</span>
                  </span>
                  <span> צד: </span>
                  <span class="lighten" style="margin-bottom:3px">
                    {{ translateSide(order.body_side) }}
                  </span>
                </div>
              </template>
              <div v-if="!isSurgery">
                <span>סוג תור: </span>
                <span class="lighten" style="margin-bottom:3px">
                  {{ event.appointmentName }}
                </span>
              </div>
              <div v-if="!isSurgery && getBubbleStatus(event)">
                <span>דיווח הגעה: </span>
                <span class="lighten">{{ getBubbleStatus(event).text }}</span>
              </div>
              <div v-if="isSurgery">
                <span>חדר: </span>
                <span class="lighten">{{ event.room.value.name }}</span>
              </div>
              <div v-if="isSurgery && event.anesthesia === 'y'">
                <span>הרדמה: </span>
                <span class="lighten">כן</span>
              </div>
              <div
                v-if="
                  isSurgery &&
                    event.hospitalizationDays &&
                    Number(event.hospitalizationDays) >= 1
                "
              >
                <span>ימי אישפוז: </span>
                <span class="lighten">{{ event.hospitalizationDays }}</span>
              </div>
              <div v-if="isSurgery && event.assistantStatus">
                <span>אסיסטנט: </span>
                <span class="lighten">{{ event.assistantStatus }}</span>
              </div>
            </div>
            <div class="td td-4" :style="isSurgery ? '' : 'width:31%;'">
              <div>
                <span>גורם משלם: </span>
                <span class="lighten">{{ event.insurance_name }}</span>
              </div>
              <div v-if="event.insurance_fee">
                <span>השתתפות עצמית: </span>
                <span class="lighten">₪{{ event.insurance_fee }}</span>
              </div>
              <div class="schedule-by">
                <span>{{ scheduledByTxt }} </span>
                <div v-if="isSurgery" class="lighten">
                  {{ event.insurance_status_heb }}
                </div>
                <template v-if="checkScheduleByExists(event)">
                  <span>{{ getScheduledBy(event.scheduled_by).text }}</span>
                  <!-- <img
                    :src="getScheduledBy(event.scheduled_by).image"
                    :alt="getScheduledBy(event.scheduled_by).text"
                  /> -->
                </template>
              </div>
              <div class="schedule-by" v-if="isSurgery && event.insurance_code">
                <span>מספר התחייבות: </span>
                <div class="lighten">
                  {{ event.insurance_code }}
                </div>
              </div>
              <div>
                <span>הגעה: </span>
                <span class="lighten">
                  {{ getArrivalStatusText(event) }}
                </span>
              </div>
              <div v-if="!isSurgery">
                <span>סטטוס תשלום: </span>
                <span class="lighten">
                  {{ getPaymentStatusText(event) }}
                </span>
              </div>
            </div>
          </div>
          <!-- NOTES SECTION -->
          <hr v-if="event.notes" class="pdf-hr" />
          <div v-if="event.notes" class="td pdf-notes">
            <div>
              <b>הערות: </b>
              {{ event.notes }}
            </div>
          </div>
          <hr v-if="event.surgery_resources" class="pdf-hr" />
          <div v-if="event.surgery_resources" class="td pdf-notes">
            <div>
              <b>משאבים: </b>
              {{ event.surgery_resources }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END TABLE -->
    <!-- TOTAL SECTION -->
    <div class="pdf-table-total bold tx--blue title--32">
      סה״כ:
      {{
        appointmentList && appointmentList.length ? appointmentList.length : 0
      }}
      {{ isSurgery ? "ניתוחים" : "תורים" }}
    </div>
    <div v-if="!isSurgery" class="pdf-table-infos flex flex--top">
      <TypesCount
        :typesCount="typesCount"
        :appointmentsDayCount="appointmentsDayCount"
        :selectedDate="selectedDate"
      />
      <ScheduledByList :scheduledByList="scheduledByList" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ScheduledByList from "@/components/Dashboard/HomeDesktop/ScheduledByList";
import TypesCount from "@/components/Dashboard/HomeDesktop/TypesCount";

export default {
  name: "PDF",
  components: {
    ScheduledByList,
    TypesCount
  },
  props: {
    appointmentList: {
      required: true
    },
    selectedDate: {
      required: true
    },
    typesCount: {
      type: Object || null
    },
    appointmentsDayCount: {
      default: () => 0
    },
    scheduledByList: {
      type: Object || null
    },
    isSurgery: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["activeDoctor"]),
    date() {
      if (!this.selectedDate) return "";
      return this.$moment(this.selectedDate).format("dddd, DD/MM/YYYY");
    },
    scheduledByTxt() {
      return this.isSurgery ? "סטטוס התחייבות: " : "מקור שיבוץ: ";
    }
  },
  methods: {
    getTime(date) {
      return this.$moment(date).format("LT");
    },
    showTimes(event) {
      return `${this.getTime(event.end)} - ${this.getTime(event.start)}`;
    },
    showName(event) {
      return this.isSurgery ? event.patient_name : event.patientName;
    },
    showPassport(event) {
      return this.isSurgery ? event.passport : event.patientPassport;
    },
    showPhone(event) {
      return this.isSurgery ? event.phone : event.patientPhone;
    },
    getScheduledBy(type) {
      return this.$store.getters["getAppScheduledBy"](type, false);
    },
    getBubbleStatus(event) {
      return this.$store.getters["getAppBubbleStatus"](
        event.status,
        event.arrival_approval
      );
    },
    getArrivalStatusText(event) {
      return event.arrival_approval &&
        event.arrival_approval.includes("approved")
        ? "אישר/ה הגעה"
        : "עדיין לא אושר";
    },
    getPaymentStatusText(event) {
      return event.payment_status ? "שולם" : "לא שולם";
    },
    translateSide(surgSide) {
      let side = "";
      if (surgSide === "Right") side = "ימין";
      else if (surgSide === "Left") side = "שמאל";
      else if (surgSide === "BIL") side = "BIL";
      else side = "לא הוגדר";
      return side;
    },
    checkScheduleByExists(event) {
      return (
        !this.isSurgery &&
        event.scheduled_by &&
        this.getScheduledBy(event.scheduled_by)
      );
    }
  }
};
</script>
